import Avatar1 from '../../assets/empty.png'
import Avatar2 from '../../assets/empty.png'
import Avatar3 from '../../assets/empty.png'
import Avatar4 from '../../assets/empty.png'
import Avatar5 from '../../assets/empty.png'
import Avatar6 from '../../assets/empty.png'
import Avatar7 from '../../assets/empty.png'


const data = [
        {
        id: 1,
        quote: "It's truly amazing how you did exactly what I want with the little information I gave. You'll be my go-to developer from today. Highly recommend!",
        avatar: Avatar1,
        name: 'Sakhumuzi Ndlovu',
        profession: 'Acting H.O.D,  Health Information - Mpilo central hospital'
        },
        {
        id: 2,
        quote: "Good job, Madangure! Right on time! I really like how the project turned out, and my customers like it as well. It was fun collaborating with you.",
        avatar: Avatar2,
        name: 'Tariro Muswewemombe',
        profession: 'Web Developer'
        },
        {
        id: 3,
        quote: "Impressive work, buddy. Highly recommend!",
        avatar: Avatar3,
        name: 'Daniel Sinyoro',
        profession: 'Graphic Designer'
        },
        {
        id: 4,
        quote: "Wow. You finished earlier than you said. Everything's modern and beautifully done to the T. Great profession!",
        avatar: Avatar4,
        name: 'Tinotenda Dziva',
        profession: 'Horticulture - Bulawayo City Council'
        },
        {
        id: 5,
        quote: "I like how the app turned out. You are incredible, Donald.",
        avatar: Avatar5,
        name: 'Vivian Choto',
        profession: 'Street Photographer'
        },
        {
        id: 6,
        quote: "Best developer in the world!",
        avatar: Avatar6,
        name: 'Elton Mbambo',
        profession: 'Brand Influencer'
        },
        {
        id: 7,
        quote: "Keep doing great stuff, dear! Nicely executed!",
        avatar: Avatar7,
        name: 'Faith Dube ',
        profession: 'UI/UX Designer'
        }
    ]



    export default data